import { render, staticRenderFns } from "./CardAppBot.vue?vue&type=template&id=bdf90726&scoped=true&"
import script from "./CardAppBot.vue?vue&type=script&lang=js&"
export * from "./CardAppBot.vue?vue&type=script&lang=js&"
import style0 from "./CardAppBot.vue?vue&type=style&index=0&id=bdf90726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf90726",
  null
  
)

export default component.exports